module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event-card",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('clickSession', _vm.session)
      }
    }
  }, [_c('div', {
    staticClass: "event-card__title"
  }, [_vm._v("\n        " + _vm._s(_vm.session.eventSessionTitle) + "\n    ")]), _vm._v(" "), (_vm.dateLink) ? _c('div', {
    staticClass: "event-card__time",
    domProps: {
      "innerHTML": _vm._s(_vm.getSessionDate(_vm.session))
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('clickTimeslot', _vm.session)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.dateLink) ? _c('div', {
    staticClass: "event-card__time event-card__time--no-link",
    domProps: {
      "innerHTML": _vm._s(_vm.getSessionDate(_vm.session))
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0b1487e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/SessionCard.vue
// module id = 77
// module chunks = 1